import { useState, useEffect, useRef } from "react"
import { AboutPath } from "../../../routes"
import Arrows from "../../../components/Icons/navy_double_arrow_left.svg"
import { Holder, ViewerPivot, Viewer, AboutLink, BackButton, BackIcon } from "./Visionaries.style"
import VisionariesSlide1 from "./VisionariesSlide1"
import VisionariesSlide2 from "./VisionariesSlide2"
import VisionariesSlide3 from "./VisionariesSlide3"
import VisionariesSlide4 from "./VisionariesSlide4"
import { useGesture } from "react-use-gesture"
import { isMobile } from "react-device-detect"

export default function Visionaries() {
  const { width } = useWindowDimensions()
  const [maxWidth, setMaxWidth] = useState(width)

  const viewerRef = useRef()
  const [scrollPos, setScrollPos] = useState(0)

  const handleDrag = state => {
    if (isMobile) {
      // setScrollPos(viewerRef.current.scrollLeft)
      return
    }

    const { direction, distance } = state
    const newPos = scrollPos - direction[0] * distance * 0.1

    if (newPos > 0 && newPos < maxWidth) {
      setScrollPos(newPos)
    }
  }

  const handleWheel = state => {
    const { direction, distance } = state
    const newPos = scrollPos + direction[1] * distance * 0.5

    if (newPos > 0 && newPos < maxWidth) {
      setScrollPos(newPos)
    }
  }

  useEffect(() => {
    //Get max scroll value
    const maxScrollLeft = viewerRef.current.scrollWidth - viewerRef.current.clientWidth
    setMaxWidth(maxScrollLeft)
  }, [])

  useEffect(() => {
    viewerRef.current.scroll({ left: scrollPos, behavior: "smooth" })
  }, [scrollPos])

  const bind = useGesture({
    onDrag: state => handleDrag(state),
    onWheel: state => handleWheel(state)
  })

  return (
    <Holder>
      <Viewer {...bind()} ref={viewerRef}>
        <ViewerPivot>
          <VisionariesSlide1 />
          <VisionariesSlide2 />
          <VisionariesSlide3 />
          <VisionariesSlide4 />
        </ViewerPivot>
      </Viewer>
      <AboutLink to={AboutPath}>
        <BackButton>
          <BackIcon src={Arrows} />
        </BackButton>
      </AboutLink>
    </Holder>
  )
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}
